import {
    Tr, Td, Flex, Button, Text, useDisclosure, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Input,
    useToast,
    Badge
} from "@chakra-ui/react";

import { useEffect, useRef, useState } from "react";
import { ReadBalance } from "./web3/readBalance";
import { ReadBalanceNative } from "./web3/readBalanceNative";
import { CheckAllowance } from "./web3/checkAllowance";
import { ApproveAllowance } from "./web3/approveAllowance";
import { ExecuteAirdrop } from "./web3/executeAirdrop";
import { ExecuteAirdropNative } from "./web3/executeAirdropNative";

import { createThirdwebClient } from "thirdweb";
import { ConnectButton, useActiveWallet, useActiveWalletChain, useSwitchActiveWalletChain } from "thirdweb/react";
import s from './web3/styles/ConnectButton.module.css';

import {
    fetcher,
    AdminPaymentsEndpoints
} from '@olagg/api-hooks'

const client = createThirdwebClient({ clientId: import.meta.env.VITE_THIRDWEB_CLIENT_ID });

const Web3ResumeItem = ({ payment, chain, refreshList }: { payment: any, chain: any, refreshList: () => void }) => {
    console.log(payment);

    const isNative = payment?.tokenType == 'NATIVE'
    const [total, setTotal] = useState<number>(0)
    const [balance, setBalance] = useState<number>(0)
    const [allowance, setAllowance] = useState<number>(0)
    const [rawAllowance, setRawAllowance] = useState(0)
    const [requiredAmount, setRequiredAmount] = useState(0)
    const [rawBalance, setRawBalance] = useState(0)
    const [allowanceVerified, setAllowanceVerified] = useState<boolean>(false)

    const isPaying = payment?.payments.length > 0 && payment?.payments[0].status == 4

    const wallet = useActiveWallet();
    const activeChain = useActiveWalletChain();

    const [account, setAccount] = useState<any>(undefined)

    useEffect(() => {
        if (wallet) {
            setAccount(wallet?.getAccount())
        }
    }, [wallet])

    useEffect(() => {
        console.log("ALLOWANCE CHANGED", rawAllowance);

    }, [rawAllowance])

    const switchChain = useSwitchActiveWalletChain();

    const handleSwitchChain = async () => {
        let newChain = chain
        newChain.id = chain.chainId
        delete newChain.chainId
        try {
            await switchChain(newChain);
            console.log(`Cambió a la red ${newChain.name}`);
        } catch (error) {
            console.error("Error al cambiar de red:", error);
            console.log("Red no encontrada, agregándola a la wallet...");
            try {
                await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [{
                        chainId: `0x${newChain.id.toString(16)}`,
                        chainName: newChain.name,
                        nativeCurrency: chain.nativeCurrency,
                        rpcUrls: newChain.rpc
                    }]
                });

                console.log("Red agregada con éxito!");
            } catch (addError) {
                console.error("Error al agregar la red:", addError);
            }
        }
    };

    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        let calcTotal = 0
        payment?.payments.map((p: any) => {
            calcTotal += p.quantity
        })
        // setTotal(calcTotal)
        let totalParsed = parseFloat(payment?.total)
        setTotal(totalParsed)
        console.log("PARSED TOTAL:", totalParsed);

    }, [isOpen])

    const [count, setCount] = useState<number>(0)
    const [needsApproval, setNeedsApproval] = useState<boolean>(false)
    const [isCheckingAllowance, setIsCheckingAllowance] = useState(true)
    const [isOwnerConnected, setIsOwnerConnected] = useState(false)


    console.log("CONDICION", needsApproval && Number(allowance) < Number(total) && Number(balance) >= Number(allowance) && Number(balance) >= Number(total))

    console.log("needsApproval", needsApproval)
    console.log("Number(allowance) < Number(total)", Number(allowance) < Number(total), Number(allowance), Number(total))
    console.log("Number(balance) >= Number(allowance)", Number(balance) >= Number(allowance), Number(balance), Number(allowance))
    console.log("Number(balance) >= Number(total)", Number(balance) >= Number(total), Number(balance), Number(total))
    console.log("typeof balance, total", balance < total, typeof balance, typeof total)

    const toast = useToast()
    const [isUpdatingStatus, setisUpdatingStatus] = useState(false)
    const manualTxHash = useRef()
    const handleManualTxHash = () => {

        const txHash = manualTxHash?.current?.value
        const isValid = /^0x([A-Fa-f0-9]{64})$/.test(txHash)

        if (!isValid) {
            toast({
                title: `El Transaction Hash no es válido`,
                colorScheme: 'olaggPink',
                status: 'error',
                description: `TX_ID: ${txHash}`,
                position: 'bottom-right'
            })
            return
        }

        if (txHash) {
            const payments = payment?.payments
            const PayloadStatusPaid = {
                data: payments.map(({ nonce }) => ({ tx_id: txHash, nonce })),
                status: 'paid'
            };

            console.log("PayloadStatusPaid", PayloadStatusPaid);

            try {
                setisUpdatingStatus(true)
                fetcher(AdminPaymentsEndpoints.bulk_update_after_airdrop(PayloadStatusPaid))
                    .then(() => {
                        toast({
                            title: `Pagos actualizados`,
                            colorScheme: 'olaggPink',
                            status: 'success',
                            description: `TX_ID: ${txHash}`,
                            position: 'bottom-right'
                        })
                        refreshList()
                    })
                    .catch(e => {
                        console.error("Error actualizar pagos", e);
                        toast({
                            title: 'Error al guardar tx_id de pagos',
                            colorScheme: 'olaggPink',
                            status: 'error',
                            description: `TX_ID: ${txHash}. Verifica que efectivamente se hizo la transferencia antes de re intentar.`,
                            position: 'bottom-right'
                        })
                    })
            } catch (error) {
                console.error("Error actualizar pagos", error);
                toast({
                    title: "Error actualizar pagos",
                    colorScheme: "red",
                    status: "error",
                    position: "bottom-right",
                });
            } finally {
                setisUpdatingStatus(false);
            }
        }

    }

    return (
        <Tr color="white">
            <Td py={'20px'}>{payment?.network}</Td>
            <Td py={'20px'}>{payment?.symbol}</Td>
            <Td py={'20px'}>{payment?.total}</Td>
            <Td py={'20px'}>{payment?.quantity}</Td>
            <Td py={'20px'}>
                {!isPaying ? (
                    <Badge borderRadius={'20px'} textAlign='center' fontSize={'14px'} py={'2px'} width={'75px'} color='black' bgColor={'#FFD600'} fontWeight='500' textTransform={'none'}>Pendiente</Badge>
                ) : (
                    <Badge borderRadius={'20px'} textAlign='center' fontSize={'14px'} py={'2px'} width={'75px'} color='black' bgColor={'white'} fontWeight='500' textTransform={'none'}>Pagando</Badge>
                )}
            </Td>
            <Td py={'20px'}>
                <Button p='0 12px' onClick={onOpen} variant={'outline'}>Operar</Button>
                <Modal isOpen={isOpen} onClose={onClose} isCentered>
                    <ModalOverlay />
                    <ModalContent mx={5} backgroundColor='#190432'>
                        <ModalCloseButton color={'white'} />
                        <>
                            <ModalHeader>
                                <Text color='white'>Operar en {payment?.network}</Text>
                            </ModalHeader>
                            <ModalBody px='20px' pb='20px' color='white'>
                                <ConnectButton
                                    appMetadata={{
                                        name: 'Ola GG',
                                        url: 'https://olagg.io'
                                    }}
                                    client={client}
                                    walletConnect={{
                                        projectId: import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID
                                    }}
                                    connectButton={{
                                        label: 'Conectar Wallet',
                                        className: s.connectButton,
                                    }}
                                    connectModal={{
                                        showThirdwebBranding: false,
                                        size: 'wide'
                                    }}
                                    detailsButton={{
                                        className: s.detailsButton,
                                    }}
                                    detailsModal={{
                                        hideBuyFunds: true,
                                        hideSwitchWallet: true,
                                        showTestnetFaucet: false,
                                    }}
                                    switchButton={{
                                        label: 'Conectar Wallet',
                                        className: s.connectButton,
                                    }}
                                    chain={chain}
                                />

                                {(account?.address && activeChain?.id == payment?.chainId) && (
                                    <>
                                        <Flex gap='16px' p='20px' w='full'>
                                            <Flex flexDirection={'column'} gap='10px' w='full'>
                                                <Flex w='full' fontSize={'18px'}>
                                                    <Flex>Total a pagar:</Flex>
                                                    <Flex ml='auto' fontWeight={'700'}>
                                                        {payment?.total} {payment?.symbol}
                                                    </Flex>
                                                </Flex>
                                                {isNative ? (
                                                    <ReadBalanceNative total={total} setRequiredAmount={setRequiredAmount} setRawBalance={setRawBalance} setBalanceAmount={setBalance} walletAddress={account?.address} chain={activeChain} client={client} />
                                                ) : (
                                                    <>
                                                        <ReadBalance setRawBalance={setRawBalance} setBalanceAmount={setBalance} symbol={payment?.symbol} walletAddress={account?.address} chain={activeChain} client={client} contractAddress={payment?.contractAddress} />
                                                        <Flex gap='5px' w='full'>
                                                            <CheckAllowance
                                                                setIsCheckingAllowance={setIsCheckingAllowance}
                                                                count={count}
                                                                symbol={payment?.symbol}
                                                                total={total}
                                                                setNeedsApproval={setNeedsApproval}
                                                                airdropContractAddress={payment?.airdropContractAddress}
                                                                contractAddress={payment?.contractAddress}
                                                                walletAddress={account?.address}
                                                                chain={activeChain}
                                                                client={client}
                                                                setAllowanceAmount={setAllowance}
                                                                setRawAllowanceAmount={setRawAllowance}
                                                                setRequiredAmount={setRequiredAmount}
                                                                setAllowanceVerified={setAllowanceVerified}
                                                            />
                                                        </Flex>
                                                    </>
                                                )}
                                            </Flex>
                                        </Flex>
                                        {isNative ? (
                                            <ExecuteAirdropNative
                                                refreshList={refreshList}
                                                setIsOwnerConnected={setIsOwnerConnected}
                                                airdropContractAddress={payment?.airdropContractAddress}
                                                payments={payment?.payments}
                                                rpc={payment?.rpcUrl}
                                                walletAddress={account?.address}
                                                chain={activeChain}
                                                client={client}
                                            />
                                        ) : (
                                            <>
                                                <Flex p='20px' flexDirection={'column'} gap='10px' w='full'>
                                                    {/* {needsApproval && rawAllowance < Number(total) && Number(balance) >= rawAllowance && Number(balance) >= Number(total) && ( */}
                                                    {needsApproval && (
                                                        <ApproveAllowance
                                                            count={count}
                                                            verifyAllowance={setCount}
                                                            airdropContractAddress={payment?.airdropContractAddress}
                                                            contractAddress={payment?.contractAddress}
                                                            payments={payment?.payments}
                                                            allowance={rawAllowance}
                                                            total={balance}
                                                            // total={total}
                                                            walletAddress={account?.address}
                                                            chain={activeChain}
                                                            client={client}
                                                        />
                                                    )}

                                                    {/* {!needsApproval && rawAllowance > 0 && rawAllowance >= total && ( */}
                                                    {!needsApproval && (
                                                        <ExecuteAirdrop
                                                            refreshList={refreshList}
                                                            setIsOwnerConnected={setIsOwnerConnected}
                                                            airdropContractAddress={payment?.airdropContractAddress}
                                                            contractAddress={payment?.contractAddress}
                                                            payments={payment?.payments}
                                                            walletAddress={account?.address}
                                                            chain={activeChain}
                                                            client={client}
                                                        />
                                                    )}
                                                </Flex>
                                            </>
                                        )}
                                    </>
                                )}

                                {(account?.address && activeChain?.id == payment?.chainId && balance < total) && (
                                    <Flex flexDirection={'column'} py='20px' gap='12px' alignItems={'center'}>
                                        <Text fontSize='18px' fontWeight='bold'>Balance insuficiente</Text>
                                        {/* <Text fontSize='18px' fontWeight='bold'>Balance insuficiente, {(balance < total).toString()} {balance} {total}</Text> */}
                                    </Flex>
                                )}

                                {(account?.address && activeChain?.id != payment?.chainId) && (
                                    <Flex flexDirection={'column'} py='20px' gap='12px'>
                                        <Text>Conectado a diferente Network</Text>
                                        <Button variant={'outline'} onClick={handleSwitchChain}>Cambiar Network</Button>
                                    </Flex>
                                )}

                                {(account?.address && activeChain?.id == payment?.chainId && rawAllowance < requiredAmount && rawBalance > requiredAmount && !isNative) && (
                                    <Flex flexDirection={'column'} py='10px' gap='12px' px='20px'>
                                        <Button variant={'outline'} onClick={() => setCount(count + 1)}>Verificar Allowance</Button>
                                    </Flex>
                                )}

                                {isPaying && (
                                    <Flex py='20px' mt='20px' color='white' flexDirection={'column'} gap='8px' borderTop={'1px solid hsl(230 11.63% 17%)'}>
                                        <Flex>
                                            <Text color='white'>Si se completó el pago, ingresar Tx Hash manualmente:</Text>
                                        </Flex>
                                        <Flex gap={'18px'} flexDirection='column'>
                                            <Input disabled={isUpdatingStatus} ref={manualTxHash} placeholder="Transaction Hash"></Input>
                                            <Button disabled={isUpdatingStatus} isLoading={isUpdatingStatus} variant={'filledGradient'} onClick={handleManualTxHash}>Confirmar pagos</Button>
                                        </Flex>
                                    </Flex>
                                )}


                            </ModalBody>
                        </>
                    </ModalContent>
                </Modal>
            </Td>
        </Tr >
    )
};

export default Web3ResumeItem;
